import * as Yup from "yup";
const generalErrorMessge = "Field is required";
export const validationSchema = Yup.object({
  pi_program_name: Yup.string()
    .required("Program Name is required")
    .min(1, "Program Name is required"),
  pi_program_type: Yup.string()
    .required("Program type is required")
    .min(1, "Program type is required"),
  pi_proposition_value: Yup.string()
    .required(generalErrorMessge)
    .min(1, generalErrorMessge),
  pi_segment_value: Yup.string()
    .required(generalErrorMessge)
    .min(1, generalErrorMessge),
  pi_setup_type: Yup.string()
    .required("Setup type is required")
    .min(1, "Setup type is required"),
  pi_type_of_migration: Yup.string().when("pi_setup_type", {
    is: (pi_setup_type) => pi_setup_type === "migration",
    then: () => Yup.string().required(generalErrorMessge),
    otherwise: () => Yup.string().optional(),
  }),

  pi_type_of_processor_name: Yup.string().when("pi_setup_type", {
    is: (pi_setup_type) => pi_setup_type === "migration",
    then: () => Yup.string().required("Bank or Processor name is required."),
    otherwise: () => Yup.string().optional(),
  }),
  pi_current_processor_name: Yup.string().required(
    "Current Processor name is required.",
  ),

  pi_key_component_custodians: Yup.array().optional(),
  pi_key_component_custodians_other: Yup.string().when(
    "pi_key_component_custodians",
    {
      is: (types) => types && types.includes(3),
      then: () => Yup.string().required("Custodian is required"),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pi_data_migration_attributes: Yup.array()
    .required("Please select a migration attribute")
    .min(1, "At least one migration attribute must be selected"),

  pi_data_migration_attributes_other: Yup.string().when(
    "pi_data_migration_attributes",
    {
      is: (attrs) => attrs && attrs.includes(16),
      then: () => Yup.string().required("Migration attribute is required."),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pi_migration_type: Yup.string()
    .required("Please select a migration attribute")
    .min(1, "At least one migration attribute must be selected"),

  pi_mig_mp_ecount_1: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_ecount_2: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_ecount_3: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_ecount_4: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evalue_1: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evalue_2: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evalue_3: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evalue_4: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evolume_1: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evolume_2: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evolume_3: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_mp_evolume_4: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" ||
        pi_migration_type === "migration-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),

  pi_mig_np_ecount_1: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_ecount_2: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_ecount_3: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_ecount_4: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evalue_1: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evalue_2: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evalue_3: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evalue_4: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evolume_1: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evolume_2: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evolume_3: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
  pi_mig_np_evolume_4: Yup.string()
    .when("pi_migration_type", {
      is: (pi_migration_type) =>
        pi_migration_type === "both" || pi_migration_type === "new-program",
      then: () => Yup.string().required(generalErrorMessge),
      otherwise: () => Yup.string().optional(),
    })
    .required(generalErrorMessge),
});
